





























































































import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment';
import * as api from '@/api';
import * as models from '@/api/models';
import { Toast } from 'vant';
import { CommonAuditStatus } from '@/api/models';
@Component({
  components: {},
})
export default class TrainingDeclarationIndex extends Vue {
  loading: boolean = false;
  finished: boolean = false;
  listData: any = [];

  get TrainRecordType() {
    return models.TrainRecordType;
  }

  mounted() {
    this.getListData();
  }
  async getListData() {
    this.loading = true;
    try {
      const { data } = await api.TrainRecords.getMyTrainRecords_GET();
      this.listData = data;
    } finally {
      this.loading = false;
      this.finished = true;
    }
  }
  dataConvert(type: any) {
    switch (type) {
      case 0:
        return '干教调训班';
      case 1:
        return '单位自主计划培训班';
      case 2:
        return '其他';
    }
  }

  /**跳转详情 */
  listDetail(item) {
    let throughState = 'through';
    if (item.orgAuditState == 0 || item.orgAuditState == 2) {
      throughState = 'noThrough';
    }
    if (item.type == this.TrainRecordType.线下)
      this.$router.push({
        name: 'declarationForm',
        query: { detailData: JSON.stringify(item), isThroughState: throughState, id: item.id },
      });
    else if (item.type == this.TrainRecordType.党委党组中心组学习)
      this.$router.push({
        name: 'LearningRecordForm',
        query: { detailData: JSON.stringify(item), isThroughState: throughState, id: item.id },
      });
  }
}
